const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '采购概况',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '公告信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '标段/标包信息',
        },
    },
    {
        component: 'ZlmTabDetail',
        options: {
            title: '包件',
            data: [],
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '采购单位信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '审核记录',
        },
    },
    {
        component: 'ZlmTabDetail',
        options: {
            title: '记录',
            data: [],
        },
    },
]

const { getApproveStatusName } = require('../approveStatus')
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        // TODO 现在没有项目有澄清问题
        getData() {
            this.$request.post(`/transformToAfter/app/track/zbggOverview`, {
                bdGuid: this.$route.query.id,
            }, { showLoading: true }).then((res) => {
                this.getGGBdList(res.data.ggGuid)
                this.getApproveList(res.data.ggGuid)

                this.config[1].options.data = {
                    '项目名称': res.data.gcName,
                    // '项目编号': '',
                    '标段名称': res.data.bdName,
                    '标段编号': res.data.bdBH,
                    '采购方式': getPurchaseTypeName(res.data.zhaoBiaoFangShi),
                    '行业分类': res.data.hangYeFenLei,
                    // '报价方式': '',
                    // '项目概况': '',
                    // '基本要求': '',
                }
                this.config[3].options.data = {
                    '公告名称': res.data.ggName,
                    // '公告发布媒体': '',
                    '公告开始时间': this.$util.timeFormatter(res.data.ggStartTime),
                    // '公告附件': '',
                }

                this.$request.post(`/transformToAfter/app/track/announce/zbGc`, {
                    bdGuid: this.$route.query.id,
                }).then((res2) => {
                    if (res2.data) {
                        this.config[7].options.data = {
                            '采购单位名称': res2.data.zbRName,
                            '采购单位地址': res2.data.zbrAddress,
                            '联系人': res2.data.lianXiRenName,
                            '联系电话': res2.data.lianXiRenPhone,
                        }
                    }
                })
            })
        },
        getGGBdList(guid) {
            this.$request.post(`/transformToAfter/app/track/announce/queryggBdList`, {
                ggGuid: guid,
            }).then((res) => {
                if (res.data && res.data.list) {
                    this.config[5].options.data = res.data.list.map((t) => ({
                        '包件名称': t.bdName,
                        '包件编号': t.bdBH,
                        '文件获取开始时间': this.$util.timeFormatter(t.zbWJHuoQuStartTime),
                        '文件获取截止时间': this.$util.timeFormatter(t.zbWJHuoQuEndTime),
                        // '澄清截止时间': '',
                        '截标/开标时间': this.$util.timeFormatter(t.kbTime),
                        '标书获取地点': t.tbWJDiJiaoDiDian,
                        '开标地点': t.kbDiDian,
                        '采购范围': t.zbFanWei,
                        '资格条件': t.ziZhiYaoQiu,
                    }))
                }
            })
        },
        getApproveList(guid) {
            this.$request.post(`/transformToAfter/app/approve/record/getApproveRecordByBusKey`, {
                // TODO 这里需要调用一个接口获取businessKey，或者自己拼接
                businessKey: `:${guid}:0`,
            }).then((res) => {
                if (res.data.length) {
                    this.config[5].options.data = res.data.map((t) => ({
                        '提交人': t.commitUserName,
                        '提交时间': this.$util.timeFormatter(t.commitTime),
                        '审批人': t.approveUserName,
                        '审批结果': getApproveStatusName(t.statusMsg),
                        '审批时间': this.$util.timeFormatter(t.approveTime),
                        '审批意见': '',
                        '审批附件': '',
                    }))
                }
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
